import React, { Component } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';
import { DomUtils, Highlighter, Typography } from '@onsolve/onsolve-ui-components';

import withKeyboardControl  from '@components/GlobalSearch/Utils/KeyboardControl';
import { globalSearchTranslations } from 'translations';

import { addSpaceToBreadCrumb } from '@components/GlobalSearch/Services/SearchService'
import SearchResultItem from './SearchResultItem';

class SearchResultsList extends Component {
    constructor(props) {
        super(props);

        this.elementRef = React.createRef();
    }

    componentDidUpdate() {
        const { selectedId } = this.props;
        const { current } = this.elementRef;

        if (selectedId && current) {
            DomUtils.setFocus(current);
            scrollIntoView(current, {
                time: 100
            });
        }
    }

    getReference = id => {
        const { selectedId, isSelected } = this.props;

        return isSelected && id === selectedId ? this.elementRef : undefined;
    };

    render() {
       const { searchResults, relatedTerm, onKeyDown, intl, onSearchSelection } = this.props;
       const relatedTermStrLabel =  intl.data[globalSearchTranslations.ng_globalSearch_alsoShowingResultsFor.id] ?? globalSearchTranslations.ng_globalSearch_alsoShowingResultsFor.defaultMessage
       const relatedTermStr = `${relatedTermStrLabel} ${relatedTerm}`

        return (
            <div onKeyDown={onKeyDown}>
                {relatedTerm && (
                    <div className="onsolve-menu-search__body__also-show-results__wrapper">
                        <Typography variant="p14" className="font-italic" color="secondary">
                            <Highlighter
                                search={relatedTerm}
                                className="font-weight-bold onsolve-menu-search__body__also-show-results__content"
                                data-test="also-show-results"
                            >
                                {relatedTermStr}
                            </Highlighter>
                        </Typography>
                    </div>
                )}
                {searchResults.map(({ results, term }, index) => {
                    const resultsCount = results.length;

                    return (
                        <div key={index} className="onsolve-menu-search__body__wrapper">
                            
                            <Typography
                                variant="p12"
                                className="onsolve-menu-search__body__search_header font-weight-bold text-secondary"
                            >
                                {`${term}`}&nbsp;
                                <span className="font-weight-normal font-italic" data-test="result-count-text">
                                    {`(${intl.data[globalSearchTranslations.ng_globalSearch_showing.id]} ${resultsCount} ${
                                        resultsCount > 1
                                            ? intl.data[globalSearchTranslations.ng_globalSearch_results.id]
                                            : intl.data[globalSearchTranslations.ng_globalSearch_result.id]
                                    })`}
                                </span>
                            </Typography>
                            {results.map(
                                ({
                                    id,
                                    parent,
                                    routeTo,
                                    redirectTo,
                                    redirectBaseUrl,
                                    menuType,
                                    isEnabled,
                                    translatedTitle,
                                    breadCrumb,
                                    newNav,
                                    onClick,
                                    icon
                                }) => (
                                    <>
                                    <SearchResultItem
                                        key={id}
                                        onSearchSelection={onSearchSelection}
                                        item={{
                                            id,
                                            parent,
                                            routeTo,
                                            menuType,
                                            isEnabled,
                                            redirectBaseUrl,
                                            redirectTo,
                                            newNav,
                                            onClick,
                                            icon
                                        }}
                                        title={translatedTitle}
                                        term={term}
                                        ref={this.getReference(id)}
                                        tabIndex={0}
                                        className="onsolve-menu-search__body__result-item"
                                        breadCrumb={addSpaceToBreadCrumb(breadCrumb)}
                                        data-test="search-results-item"
                                    />
                                    </>
                                )
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }
}

SearchResultsList.propTypes = {
    intl: PropTypes.object,
    isSelected: PropTypes.bool,
    onKeyDown: PropTypes.func,
    onSearchSelection: PropTypes.func,
    relatedTerm: PropTypes.string,
    searchResults: PropTypes.array,
    selectedId: PropTypes.string,
};

export default withKeyboardControl(SearchResultsList);
